import React from 'react';
const pains = [{
  emoji: '😰',
  title: 'Constant Practice Planning',
  description: 'Every week you spend hours creating practice plans, organizing drills, preparing skill progressions, designing conditioning exercises, and adapting sessions for athletes with different ages, abilities, and competitive levels.'
}, {
  emoji: '⚠️',
  title: 'Unsure What to Teach Next',
  questions: ['What skill should we practice today?', 'Are my athletes ready for the next progression?', 'How can I safely introduce more difficult movements?', 'What should I do with athletes who are all at different levels?'],
  description: 'Planning every session becomes a constant challenge.'
}, {
  emoji: '📚',
  title: 'Coaching Resources Everywhere',
  resources: ['Skill progressions.', 'Drill collections.', 'Conditioning exercises.', 'Practice ideas.', 'Competition preparation.', 'Coaching notes.'],
  description: "Everything exists… but it's scattered across books, websites, coaching courses, PDFs, YouTube videos, and dozens of folders on your computer. Nothing is organized into one complete coaching system you can confidently use every day."
}, {
  emoji: '😩',
  title: 'Coaching Burnout',
  description: 'Between planning practices, preparing stations, organizing equipment, tracking athlete progress, creating season plans, and getting ready for competitions, there’s very little time left to focus on what truly matters: helping your gymnasts improve their skills and perform with confidence.'
}];
export function PainSection() {
  return <section className="py-8 px-4 bg-brand-cloud border-y border-brand-line" data-id="element-117">
      <div className="max-w-4xl mx-auto" data-id="element-118">
        <h2 className="text-2xl sm:text-3xl font-display font-extrabold text-center text-brand-ink mb-2 uppercase tracking-tight" data-id="element-119">
          Does This Sound Familiar?
        </h2>

        <p className="text-base sm:text-lg text-brand-slate font-medium text-center mb-6 max-w-2xl mx-auto leading-snug" data-id="element-120">
          You love coaching gymnastics, but planning every practice is consuming
          your entire week. If you're a gymnastics coach working in clubs,
          academies, schools, recreational programs, competitive teams, or
          private coaching, you've probably experienced at least one of these
          situations:
        </p>

        <div className="grid sm:grid-cols-2 gap-3" data-id="element-121">
          {pains.map((pain, i) => <div key={i} className="bg-white p-4 rounded-xl border border-brand-line shadow-sm flex flex-col items-center text-center sm:items-start sm:text-left sm:flex-row gap-3" data-id="element-122">
              <div className="text-3xl shrink-0" data-id="element-123">{pain.emoji}</div>
              <div data-id="element-124">
                <h3 className="text-base font-bold text-brand-navy mb-1 uppercase tracking-wide" data-id="element-125">
                  {pain.title}
                </h3>
                {pain.questions && <ul className="text-brand-slate text-sm font-semibold leading-snug mb-1.5 space-y-0.5 list-disc list-inside marker:text-brand-blue" data-id="element-126">
                    {pain.questions.map((q, qi) => <li key={qi} data-id="element-127">{q}</li>)}
                  </ul>}
                {pain.resources && <ul className="text-brand-slate text-sm font-semibold leading-snug mb-1.5 grid grid-cols-2 gap-x-3" data-id="element-128">
                    {pain.resources.map((r, ri) => <li key={ri} data-id="element-129">{r}</li>)}
                  </ul>}
                <p className="text-brand-slate text-sm font-medium leading-snug" data-id="element-130">
                  {pain.description}
                </p>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}